export const checkAccountCompletion = () => () => {};
